module.exports = __webpack_public_path__ + "static/media/ic_pause.851896ad.svg";